import { Props } from '../Layout'
import { useProps as useGlobalNavigationLayoutProps } from '../../../parts/commons/GlobalNavigationLayout/useProps'
import { useTabBarProps, Params as UseTabBarPropsParams } from './useTabBarProps'
import { useArcadePartsAndArcadeMachinesCountsQuery } from '../query.generated'
import { useLoginUser } from '@/src/views/states/LoginUser'

export type Params = {} & UseTabBarPropsParams

export const useProps = ({ activeTab }: Params): Props => {
  const userId = useLoginUser().loginUser?.id ?? ''
  const query = useArcadePartsAndArcadeMachinesCountsQuery({
    variables: {
      where: { userId: { equals: userId } },
      aggregateArcadeMachineWhere2: { userId: { equals: userId } },
    },
  })
  const amCounts = query.data?.aggregateArcadeMachine._count?.id ?? 0
  const apCounts = query.data?.aggregateArcadePart._count?.id ?? 0
  return {
    status: query.loading ? 'LOADING' : amCounts + apCounts === 0 ? 'NO_NFTS' : 'VISIBLE',
    TabBarProps: useTabBarProps({ activeTab }),
    GlobalNavigationLayoutProps: useGlobalNavigationLayoutProps({ activeMenu: 'ArcadeMachineManager' }),
  }
}
